@if (waiting$ | async; as waiting) {
  @if (waiting.count > 0) {
    <span class="waiting-badge" [class.checking]="waiting.isChecking">{{ waiting.count }}</span>
  }
}
